import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "hiddenField", "collapseButton"]
  static values = {
    notSelected: String,
    selected: String,
    selectedId: String
  }

  // La même fonction à l'ajout et au retrait : un `.bind` à chaque appel en donnait une autre, l'écouteur n'était jamais
  // retiré et s'accumulait à chaque étape montée puis démontée (panneau latéral de la fiche du catalogue).
  initialize() {
    this.onFrameLoad = this.checkForPreselection.bind(this)
  }

  connect() {
    document.addEventListener('turbo:frame-load', this.onFrameLoad)
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this.onFrameLoad)
    if (document.getElementById('selector-collapse-button')) {
      document.getElementById('selector-collapse-button').removeEventListener('click', this.handleCollapse.bind(this));
    }
  }

  checkForPreselection() {
    // Iterate through all buttons
    this.buttonTargets.forEach(button => {
      // Check if the button is selected
      if (button.classList.contains('btn-outline-danger')) {
        // If selected, update the hidden field with the dataset.parentId of the selected button
        this.hiddenFieldTarget.value = button.dataset.parentId;
      }
    });
  }

  choose(event) {
    event.preventDefault()
    const button = event.currentTarget;
    const parentId = button.dataset.parentId;
    this.toggleSelection(button, parentId);
  }

  selectById(parentId) {
    const button = this.buttonTargets.find(button => button.dataset.parentId === parentId);
    if (button) {
      this.toggleSelection(button, parentId);
    }
  }

  toggleSelection(button, parentId) {
    // Check if the button is already selected
    if (this.hiddenFieldTarget.value === parentId) {
      // Deselect the button
      this.hiddenFieldTarget.value = ""
      this.updateButtons(null)
    } else {
      // Select the button
      this.hiddenFieldTarget.value = parentId
      this.updateButtons(button)
    }

    // Check for the autosubmit attribute or onchange attribute
    if (this.hiddenFieldTarget.hasAttribute('data-autosubmit') || this.hiddenFieldTarget.getAttribute('onchange') === 'form.requestSubmit()') {
      // Trigger form submission
      this.hiddenFieldTarget.closest('form').requestSubmit()
    }
  }

  updateButtons(selectedButton) {
    this.buttonTargets.forEach(button => {
      if (button === selectedButton) {
        button.classList.add('btn-outline-danger')
        button.classList.remove('btn-link', 'bg-shadow')
        button.innerHTML = this.selectedValue
      } else {
        button.classList.add('btn-link', 'bg-shadow')
        button.classList.remove('btn-outline-danger')
        button.innerHTML = this.notSelectedValue
      }
    })
  }

  handleCollapse() {
    const isExpanded = this.collapseButtonTarget.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      // Désélectionner l'élément
      this.deselectCurrentSelection();
    } else {
      // Resélectionner l'élément précédemment sélectionné
      this.reselectPreviousSelection();
    }
  }

  deselectCurrentSelection() {
    const selectedButton = this.buttonTargets.find(button => button.classList.contains('btn-outline-danger'));
    if (selectedButton) {
      this.toggleSelection(selectedButton, selectedButton.dataset.parentId);
      // Sauvegarder l'ID pour une utilisation future
      this.previousSelectionId = selectedButton.dataset.parentId;
    }
  }

  reselectPreviousSelection() {
    if (this.previousSelectionId) {
      this.selectById(this.previousSelectionId);
      this.previousSelectionId = null; // Réinitialiser après la re-sélection
    }
  }
}
